import {each, find, round} from 'lodash';

const LabelGeneratorPlugin = {
    install: function (Vue, options) {
        if (!options) {
            options = {};
        }

        Vue.prototype.$label = async function (type, object, printer, callback) {
            if (!printer) {
                printer = 'zebra';
            }

            let processor_name_abbreviated = (object.processor_name || (object.order && object.order.processor_name) || 'Unknown');
            if (processor_name_abbreviated !== 'Unknown') {
                processor_name_abbreviated = processor_name_abbreviated.match(/(\b\S{2})/)[1].concat('', processor_name_abbreviated.match(/(?:(\b\S{1})\w*$)/)[1]);
            }
            object.processor_name_abbreviated = processor_name_abbreviated;


            console.log('Printing label: ', object);

            switch (type) {
                case 'fedex':
                    await this.$printer.printRaw(printer, fedexTemplate(object));
                    break;

                case 'order':
                    await this.$printer.printRaw(printer, orderTemplate(object));
                    break;

                case 'fulfillment_order':
                    await this.$printer.printRaw(printer, fulfillmentOrderTemplate(object));
                    break;

                case 'hold':
                case 'item':
                    if (object.type && object.type.id === 33) { // Diamond
                        await this.$printer.printRaw(printer, diamondTemplate(object));
                    } else {
                        await this.$printer.printRaw(printer, itemTemplate(object, type));
                    }
                    break;

                case 'bag':
                    await this.$printer.printRaw(printer, bagTemplate(object));
                    break;

                case 'address':
                    await this.$printer.printRaw(printer, addressTemplate(object));
                    break;
            }


            if (callback) {
                callback();
                return false;
            } else {
                return true;
            }
        };

        function orderTemplate(object) {

            let printData = `
                ^XA
^LH0,0
^CF0,30,30
^PW609
~SD7

^PON

^FO20,20
^AU
^FB609,2,0,C
^FDO#: ${object.id}^FS

^FO20,220
^AT,20,20
^FB609,3,10,L
^FDC: ${object.customer.first_name} ${object.customer.last_name}^FS

^FO20,260
^AQ
^FB609,3,6,L
^FD
Processed By: ${object.processor_name_abbreviated}\\&
Processed On: ${new Date(object.appraised_at).toLocaleString('en-US', {timeZone: 'America/New_York'})}^FS
`;

            // Reverse Ship
            if (object.status_id === 11) {
                printData += `
^FO120,80
^BY3,3
^B3N,N,120,N
^FDR${object.id}^FS

^FO20,340
^GB60,50,50,,^FS
^FO20,350
^AT
^FB60,,,C
^FR^FDRS\\&^FS
`;
            } else {
                printData += `
^FO120,80
^BY3,2
^B3N,N,120,N
^FDO${object.id}^FS
`;
            }

            // Split Kit
            if (find(object.flags, ['flag_type_id', 33])) {
                printData += `
^FO100,340
^GB110,50,50,,^FS
^FO105,350
^AT
^FB100,,,C
^FR^FDSPLIT\\&^FS
`;
            }

            printData += `
^PQ1
^XZ`;

            return printData;
        }

        function fulfillmentOrderTemplate(object) {

            return `
                ^XA
^LH0,0
^CF0,30,30
^PW609
~SD7

^PON

^FO20,20
^AU
^FB609,2,0,C
^FDO#: ${object.order.id}^FS

^FO120,80
^BY3,3
^B3N,N,100,N
^FDO${object.order.id}^FS

^FO20,200
^AT,20,20
^FB609,3,10,L
^FDCustomer: ${object.customer.first_name} ${object.customer.last_name}^FS

^FO20,240
^AT,20,20
^FB609,3,10,L
^FDTracking#: ${object.order.mail_tracking_number}^FS

^PQ3
^XZ`;
        }

        function bagTemplate(object) {

            let indicator = null;
            let mixed_metal = null;
            let contains_melee = null;
            let brand_packaging = null;
            let purity_string = '';
            let inserts = null;
            let bag_size = null;
            switch (object.class) {
                case 'gold':
                    indicator = 'Au';
                    break;
                case 'gold-filled':
                    indicator = 'GF';
                    break;
                case 'gold-plated':
                    indicator = 'GP';
                    break;
                case 'silver-plated':
                    indicator = 'AgP';
                    break;
                case 'platinum':
                    indicator = 'Pt';
                    break;
                case 'palladium':
                    indicator = 'Pd';
                    break;
                case 'silver':
                    indicator = 'Ag';
                    break;
                case 'other':
                    indicator = 'O';
                    break;
                case 'dental':
                    indicator = 'Den';
                    break;
                default:
                    indicator = (object.class.length < 4) ? object.class : '?';
                    break;
            }

            switch (object.bag_type_id) {
                case 1:
                    bag_size = 'SM';
                    break;
                case 2:
                    bag_size = 'MED';
                    break;
                case 3:
                    bag_size = 'LG';
                    break;
                case 4:
                    bag_size = 'XL';
                    break;
            }

            if (object.purity_type !== null) {
                let purity = object.purity ? object.purity : 0;
                let purity_type = object.purity_type;
                purity_string = purity + ' ' + purity_type;
            }

            let item_count = 0;

            each(object.inventory, (inventory) => {
                item_count += inventory.quantity;
                each(inventory.children, (child) => {
                    if (object.class === 'dental') {
                        if (child && child.class_name !== object.inventory[0].children[0].class_name && child.class_name !== 'diamond' && child.class_name !== 'melee' && child.class_name !== 'dental' && child.class_id !== 11 /*other*/) {
                            mixed_metal = true;
                        }
                    } else {
                        if (
                            (child && child.class_name !== object.class
                                && child.class_name !== 'diamond'
                                && child.class_name !== 'melee'
                                && child.class_name !== 'dental'
                                && child.class_id !== 11)
                            ||
                            (child && child.class_name === inventory.children[0].class_name
                                && (child.purity_type !== inventory.children[0].purity_type
                                    || child.purity !== inventory.children[0].purity)
                            )
                            // child && child.class_name !== object.class && child.class_name !== 'diamond' && child.class_name !== 'melee' && child.class_name !== 'dental' && child.class_id !== 11 /*other*/
                        ) {
                            mixed_metal = true;
                        }
                    }

                    if (child && child.class_name !== object.class && child.class_name === 'melee') {
                        contains_melee = true;
                    }
                });

                if (inventory.additional_packaging) {
                    brand_packaging = true;
                }
            });

            if (mixed_metal && contains_melee && brand_packaging) { // All indicators
                inserts = `
^FO30,320
^GB60,54,50,,^FS
^FO30,330
^AT
^FB60,,,C
^FR^FDM\\&^FS

^FO100,320
^GB80,54,50,,^FS
^FO90,330
^AT
^FB100,,,C
^FR^FDM/M\\&^FS

^FO190,320
^GB60,54,50,,^FS
^FO190,330
^AT
^FB60,,,C
^FR^FDPM\\&^FS
                `;
            } else if (mixed_metal && (contains_melee || brand_packaging)) { // Mixed Metal Plus indicators
                inserts = `
^FO50,320
^GB80,54,50,,^FS
^FO50,330
^AT
^FB80,,,C
^FR^FDM/M\\&^FS
                `;

                if (contains_melee) {
                    inserts += `
^FO150,320
^GB60,54,50,,^FS
^FO150,330
^AT
^FB60,,,C
^FR^FDM\\&^FS
                    `;
                } else if (brand_packaging) {
                    inserts += `
^FO150,320
^GB60,54,50,,^FS
^FO150,330
^AT
^FB60,,,C
^FR^FDPM\\&^FS
                    `;
                }
            } else if (contains_melee && brand_packaging) {
                inserts = `
^FO50,320
^GB60,54,50,,^FS
^FO50,330
^AT
^FB60,,,C
^FR^FDM\\&^FS

^FO150,320
^GB60,54,50,,^FS
^FO150,330
^AT
^FB60,,,C
^FR^FDPM\\&^FS
                `;
            } else {
                if (mixed_metal) {
                    inserts = `
^FO100,320
^GB80,54,50,,^FS
^FO100,330
^AT
^FB80,,,C
^FR^FDM/M\\&^FS
                    `;
                }
                if (contains_melee) {
                    inserts = `
^FO100,320
^GB60,54,50,,^FS
^FO100,330
^AT
^FB60,,,C
^FR^FDM\\&^FS
                    `;
                }
                if (brand_packaging) {
                    inserts = `
^FO100,320
^GB60,54,50,,^FS
^FO100,330
^AT
^FB60,,,C
^FR^FDPM\\&^FS
                    `;
                }
            }

            let printData = `
^XA
^LH0,0
^CF0,30,30
^PW609
~SD7

^PON

^FO15,30
^AV,140,140
^FB220,,,C
^FD${indicator}\\&^FS

^FO30,170
^A0,50,50
^FB200,,,C
^FD${purity_string}\\&^FS

^FO30,220
^FB200,,,C
^FDBag\\&^FS

^FO30,250
^FB200,,,C
^FD${item_count} item(s)\\&^FS

^FO30,290
^FB200,,,C
^FD${round(object.dwt, 2)} dwt\\&^FS

^FO260,30
^A0,40,40
^FB320,3,10,L
^FDO:${object.order.id}\\&
${object.customer.first_name} ${object.customer.last_name}^FS

^FO260,180
^A0,20,20
^FB320,2,10,L
^FD${new Date(object.order.appraised_at).toLocaleString('en-US', {timeZone: 'America/New_York'})}\\&
${object.processor_name_abbreviated}^FS

^FO260,240
^BY2,3
^B3N,N,60,N
^FDB${object.id}\\&
^FS

^FO260,320
^AU
^FB320,2,10,L
^FDB:${object.id}^FS

^FO550,310
^GB40,54,40,,^FS
^FO550,324
^AT
^FB40,,,C
^FR^FDB\\&^FS

${inserts}

^FO530,20
^GB70,46,3,,5^FS
^FO530,32
^A0,30,30
^FB70,,,C
^F^FD${bag_size}\\&^FS

^PQ1
^XZ
            `;
            return printData;
        }

        function itemTemplate(object, type) {

            let indicator = null;
            let mixed_metal = null;
            let contains_melee = null;
            let diamond_condition = null;
            let brand_packaging = null;
            let purity_string = '';
            let quantity = 1;
            let inserts = null;
            let bag_size = null;

            if (object.children[0] && object.children[0].class) {
                indicator = object.children[0].class.indicator;
            } else if (object.children[0] && object.children[0].class_name) {
                switch (object.children[0].class_name) {
                    case 'gold':
                        indicator = 'Au';
                        break;
                    case 'gold-filled':
                        indicator = 'GF';
                        break;
                    case 'gold-plated':
                        indicator = 'GP';
                        break;
                    case 'silver-plated':
                        indicator = 'AgP';
                        break;
                    case 'platinum':
                        indicator = 'Pt';
                        break;
                    case 'palladium':
                        indicator = 'Pd';
                        break;
                    case 'silver':
                        indicator = 'Ag';
                        break;
                    case 'other':
                        indicator = 'O';
                        break;
                    case 'dental':
                        indicator = 'Den';
                        break;
                    default:
                        indicator = (object.class.length < 4) ? object.class : '?';
                        break;
                }
            } else {
                indicator = '?';
            }

            if (object.bag && object.bag.bag_type_id && (type === 'hold' || object.inventory_status_id === 2)) {
                switch (object.bag.bag_type_id) {
                    case 1:
                        bag_size = 'SM';
                        break;
                    case 2:
                        bag_size = 'MED';
                        break;
                    case 3:
                        bag_size = 'LG';
                        break;
                    case 4:
                        bag_size = 'XL';
                        break;
                }
            }

            if (object.children[0].class_name !== 'melee' && object.children[0].purity_type !== null) {
                let purity = object.children[0].purity ? object.children[0].purity : 0;
                let purity_type = object.children[0].purity_type;
                purity_string = purity + ' ' + purity_type;
            }

            if (type === 'hold') {
                quantity = (object.children[0] && object.children[0].quantity > 0) ? (object.children[0].quantity) : 1;
            } else {
                quantity = (object.children[0] && object.children[0].quantity > 0) ? (object.children[0].quantity * object.quantity) : object.quantity;
            }


            each(object.children, (child) => {
                if (
                    (child && child.class_name !== object.children[0].class_name
                        && child.class_name !== 'diamond'
                        && child.class_name !== 'melee'
                        && child.class_name !== 'dental'
                        && child.class_id !== 11)
                    ||
                    (child && child.class_name === object.children[0].class_name
                        && (child.purity_type !== object.children[0].purity_type
                            || child.purity !== object.children[0].purity)
                    )
                ) {
                    mixed_metal = true;
                }

                if (child && child.class_name !== object.children[0].class_name && child.class_name === 'melee') {
                    contains_melee = true;
                }

                if (child && child.class_name !== object.children[0].class_name && child.class_name === 'diamond') {
                    diamond_condition = child.condition_name;
                }
            });

            if (object.additional_packaging) {
                brand_packaging = true;
            }

            if (mixed_metal && contains_melee && brand_packaging) { // All indicators
                inserts = `
^FO30,320
^GB60,54,50,,^FS
^FO30,330
^AT
^FB60,,,C
^FR^FDM\\&^FS

^FO100,320
^GB80,54,50,,^FS
^FO90,330
^AT
^FB100,,,C
^FR^FDM/M\\&^FS

^FO190,320
^GB60,54,50,,^FS
^FO190,330
^AT
^FB60,,,C
^FR^FDPM\\&^FS
                `;
            } else if (mixed_metal && (contains_melee || brand_packaging)) { // Mixed Metal Plus indicators
                inserts = `
^FO50,320
^GB80,54,50,,^FS
^FO50,330
^AT
^FB80,,,C
^FR^FDM/M\\&^FS
                `;

                if (contains_melee) {
                    inserts += `
^FO150,320
^GB60,54,50,,^FS
^FO150,330
^AT
^FB60,,,C
^FR^FDM\\&^FS
                    `;
                } else if (brand_packaging) {
                    inserts += `
^FO150,320
^GB60,54,50,,^FS
^FO150,330
^AT
^FB60,,,C
^FR^FDPM\\&^FS
                    `;
                }
            } else if (contains_melee && brand_packaging) {
                inserts = `
^FO50,320
^GB60,54,50,,^FS
^FO50,330
^AT
^FB60,,,C
^FR^FDM\\&^FS

^FO150,320
^GB60,54,50,,^FS
^FO150,330
^AT
^FB60,,,C
^FR^FDPM\\&^FS
                `;
            } else {
                if (mixed_metal) {
                    inserts = `
^FO100,320
^GB80,54,50,,^FS
^FO100,330
^AT
^FB80,,,C
^FR^FDM/M\\&^FS
                    `;
                }
                if (contains_melee) {
                    inserts = `
^FO100,320
^GB60,54,50,,^FS
^FO100,330
^AT
^FB60,,,C
^FR^FDM\\&^FS
                    `;
                }
                if (brand_packaging) {
                    inserts = `
^FO100,320
^GB60,54,50,,^FS
^FO100,330
^AT
^FB60,,,C
^FR^FDPM\\&^FS
                    `;
                }
            }

            if (diamond_condition) {
                inserts += `
^FO270,375
^FB320,2,4,R
^A0,20,20
^FDDIAMOND: ${diamond_condition}\\&^FS
                `;
            }

            let printData = `
^XA
^LH0,0
^CF0,30,30
^PW609
~SD7

^PON`;
            if (type === 'hold' || object.inventory_status_id === 2) {
                printData += `
^FO30,40
^GB100,120,100,,^FS

^FO30,50
^AV,130,130
^FB100,,,C
^FR^FDH\\&^FS

^FT140,160
^AW,80,80
^FB200,,,L
^FD${indicator}\\&^FS
`;

                if (object.brand_name) {
                    printData += `
^FO260,370
^A1,30,26
^FB360,,,L
^FDBrand: ${object.brand_name}^FS
`;
                }
            } else {
                printData += `
^FO15,30
^AV,140,140
^FB220,,,C
^FD${indicator}\\&^FS
`;
            }

            printData += `

^FO30,170
^A0,50,50
^FB200,,,C
^FD${purity_string}\\&^FS

^FO30,220
^FB200,,,C
^FD${object.type.label_name}\\&^FS

^FO30,250
^FB200,,,C
^FDQty: ${quantity}\\&^FS

^FO30,290
^FB200,,,C
^FD${round(object.aggregate_dwt, 2)} dwt\\&^FS

^FO260,30
^A0,40,40
^FB320,3,10,L
^FDO:${object.order.id}\\&
${object.customer.first_name} ${object.customer.last_name}^FS

^FO260,180
^A0,20,20
^FB320,2,10,L
^FD${new Date(object.order.appraised_at).toLocaleString('en-US', {timeZone: 'America/New_York'})}\\&
${object.processor_name_abbreviated}^FS

^FO260,240
^BY2,3
^B3N,N,60,N
^FDI${object.id}\\&
^FS

^FO260,320
^AU
^FB320,2,10,L
^FDI:${object.id}^FS

${inserts}`;

            if (bag_size) {
                printData += `
^FO530,20
^GB70,46,3,,5^FS
^FO530,32
^A0,30,30
^FB70,,,C
^F^FD${bag_size}\\&^FS
`;
            }

            printData += `
^PQ1
^XZ
            `;
            return printData;
        }

        function diamondTemplate(object) {
            
            let printData = `
^XA
^LH0,0
^CF0,30,30
^PW609
~SD7

^PON^FO30,30
^FB200,,,C
^FDDiamond\\&^FS

^FO30,85
^AV,160,160
^FB200,,,C
^FDD\\&^FS

^FO50,60
^GC150,4B
^FS

^FO30,230
^FB200,2,4,C
^A0,20,20
^FDREPORT\\&
${object.children[0].certificate_name || '-'} ${object.children[0].certificate_number || '-'}^FS

^FO30,290
^FB200,2,4,C
^A0,20,20
^FDQTY: ${object.children[0].quantity}^FS

^FO30,330
^FB220,4,10,C
^A0,20,20
^FD${new Date(object.order.appraised_at).toLocaleString('en-US', {timeZone: 'America/New_York'})}\\&
${object.processor_name_abbreviated}^FS

^FO260,30
^A0,40,40
^FB320,3,10,C
^FDO:${object.order.id}^FS

^FO260,80
^A0,20,20
^FB160,2,10,C
^FDCOLOR^FS

^FO260,110
^AU,20,20
^FB160,2,10,C
^FD${object.children[0].color_name}\\&^FS

^FO420,80
^A0,20,20
^FB160,2,10,C
^FDCLARITY^FS

^FO420,110
^AU,20,20
^FB160,2,10,C
^FD${object.children[0].clarity_name}\\&^FS

^FO260,170
^A0,20,20
^FB160,2,10,C
^FDCUT^FS

^FO260,200
^AT,20,20
^FB160,2,10,C
^FD${object.children[0].style_name}\\&^FS

^FO420,170
^A0,20,20
^FB160,2,10,C
^FDCARAT^FS

^FO420,200
^AT,20,20
^FB160,2,10,C
^FD${object.children[0].tare_weight}\\&^FS

^FO270,250
^BY2
^B3N,N,60,N
^FDI${object.id}\\&
^FS

^FO270,320
^AU
^FB320,2,10,L
^FDI:${object.id}^FS

^FO270,375
^FB320,2,4,R
^A0,20,20
^FDCONDITION: ${object.children[0].condition_name || '-'}\\&^FS

^PQ1
^XZ
            `;
            return printData;
        }

        function addressTemplate(object) {

            let kit_indicator = 'L';
            if (object.order.id % 2 === 0) {
                kit_indicator = 'S';
            }

            let printData = `^XA
^LH0,0
^PW800
^CF0,28

^FO724,40,1
^AQ
^FDC${object.customer.id}*O${object.order.id}*${object.brand.abbreviation}***${kit_indicator}^FS

^FO740,40,1
^AR
^FD^FS

^FO100,146
^A0,30
^FD${object.customer.first_name} ${object.customer.last_name}^FS

^FO100,191
^FD${object.customer.address.address2}^FS

^FO100,229
^FD${object.customer.address.address1}^FS

^FO100,267
^FD${object.customer.address.city}, ${object.customer.address.state} ${object.customer.address.zip}^FS

^FO100,340
^BY4
^BZ,30,,,3
^FD00310902170762${object.id}${object.customer.address.zip.replace('-', '')}^FS

^XZ`;

            return printData;
        }

        function fedexTemplate(object) {
            let inbound_text = '';
            if (object.expected_delivery_at) {
                inbound_text = `^FO440,28
                ^GB160,46,3,,5^FS
                ^FO440,40
                ^A0,30,30
                ^FB170,,,C
                ^F^FDINBOUND^FS`;
            }

            let printData = `^XA
^LH0,0
^CF0,30,30
^PW609
~SD7

^PON
${inbound_text}
^FO40,40
^FDORDER:${object.order_id}^FS
^FO40,100
^AO
^FDTRACKING:${object.tracking_number}^FS
^FO40,160
^BY2
^B3N,N,120,N
^FD${object.tracking_number}^FS
^PQ1
^XZ`;

            return printData;
        }

    }
};

export default LabelGeneratorPlugin;
